// extracted by mini-css-extract-plugin
export default {"jobContent":"JobContent_jobContent__+d2A7"};